import { useState } from 'react';
import { Smile } from 'lucide-react';
import { Button } from './ui/button';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const EMOJIS = [
  '😀', '😃', '😄', '😁', '😊', '🙂', '😉', '😍', '🥰', '😘',
  '😎', '🤔', '😅', '😂', '😐', '😴', '😢', '😭', '😡', '😮',
  '😲', '🙌', '👍', '👎', '👏', '🙏', '💪', '🤝', '👋', '✅',
  '❌', '⚠️', '❤️', '💊', '🩺', '📋', '📎', '🖼️', '⏰', '📅',
  '🎉', '🔥', '💯', '🤒', '🤧', '😬', '🤗', '🤷', '🚑', '💉',
];

export const EmojiPicker = ({ onSelect, testId = 'emoji-picker', disabled = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button" variant="ghost" size="icon" disabled={disabled}
          className="shrink-0" title="Add an emoji" data-testid={`${testId}-trigger`}
        >
          <Smile className="w-4 h-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2" align="start" data-testid={`${testId}-panel`}>
        <div className="grid grid-cols-8 gap-0.5 max-h-48 overflow-y-auto">
          {EMOJIS.map((emoji, i) => (
            <button
              key={emoji} type="button"
              className="text-lg leading-none p-1.5 rounded hover:bg-muted transition-colors"
              onClick={() => { onSelect(emoji); setOpen(false); }}
              data-testid={`${testId}-option-${i}`}
              aria-label={`Insert ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
